import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import CashAccountBankDetails from "../CashAccountBankDetails";
import ModelProxyClass from "./ModelProxyClass";


/**
 * @class CashAccountBankDetailsBase
 * @extends ModelBaseClass
 * @property {string} address1
 * @property {string} address2
 * @property {string} city
 * @property {string} state
 * @property {string} zip
 */
class CashAccountBankDetailsBase extends ModelBaseClass {
	/**
	 * @type {string} address1
	 */
	address1;
	/**
	 * @type {string} address2
	 */
	address2;
	/**
	 * @type {string} city
	 */
	city;
	/**
	 * @type {string} state
	 */
	state;
	/**
	 * @type {string} zip
	 */
	zip;

	/**
	 * Instantiates a new instance of CashAccountBankDetails based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {CashAccountBankDetails}
	 */
	static create(genericObject) {
		const newCashAccountBankDetails = new CashAccountBankDetails();
		newCashAccountBankDetails.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newCashAccountBankDetails;
	}

	/**
	 * Instantiates a new array of CashAccountBankDetails based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[CashAccountBankDetails]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newCashAccountBankDetailsArray = [];
		genericArray.forEach(genericObject => {
			newCashAccountBankDetailsArray.push(CashAccountBankDetails.create(genericObject));
		});
		return newCashAccountBankDetailsArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('address1', 'string'),
	ModelBaseClass.createModelProperty('address2', 'string'),
	ModelBaseClass.createModelProperty('city', 'string'),
	ModelBaseClass.createModelProperty('state', 'string'),
	ModelBaseClass.createModelProperty('zip', 'string'),
];

export default CashAccountBankDetailsBase;
